// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteListBody = {};

export type typeInviteListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    pendingCount: number;
    invites: {
      inviteId: string;
      poolId: string;
      poolName: string;
      invitedByName: string;
      sportLabel: string;
      contestLabel: string;
      sentAtLabel: string;
      bannerImageUrl?: string | null;
      creatorHandle?: string | null;
      source: "addressed" | "link";
    }[];
  };
};

export type typeInviteListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteListBody = { type: "object", properties: {} } as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteListBody);
  }

  return async function postInviteList(
    payload: typeInviteListBody,
  ): Promise<typeInviteListOutput200 | typeInviteListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteList" failed before calling the network. #f9625804757e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f9625804757e" },
        },
        data: null,
      } as typeInviteListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/list`,
      httpMethod: "POST",
      options,
    })) as typeInviteListOutput200 | typeInviteListOutput400;
  };
}
